<nb-card>
    <nb-card-header>{{data.name}}</nb-card-header>
    <nb-card-body>
        <p>{{"UNIT_RATES" | translate }}: {{unitrate}}</p>
        <p>{{"STANDING_CHARGES" | translate }}: {{standingcharge}}</p>
        <p>{{"TARIFF_TYPE" | translate }}: <span style="text-transform: capitalize">{{tarifftype}}</span></p>
    </nb-card-body>
    <nb-card-footer><button nbButton (click)="close()">{{"CLOSE" | translate}}</button></nb-card-footer>
</nb-card>